export default "__VITE_ASSET__YxoWDf1A__"